import { Grid } from '@mui/material';
import { VaultHeader } from './VaultHeader';
import React, { useMemo } from 'react';
import { VaultUnstakingTable } from './VaultUnstakingTable';
import { useStakingContext } from '../contexts/staking.context';

export const Withdraw = () => {
  const { unstakeList } = useStakingContext();
  const unstakeColumns = [
    {
      id: 1,
      columnName: 'OZK To Unstake',
    },
    {
      id: 2,
      columnName: 'Unstake Initiated',
    },
    {
      id: 3,
      columnName: 'Estimated Date Available for Withdrawal',
    },
  ];
  const filtredUnstakeList = useMemo(
    () => unstakeList.filter((transaction) => !transaction?.processed),
    [unstakeList],
  );

  return (
    <VaultUnstakingTable
      unstakeList={filtredUnstakeList}
      unstakeColumns={unstakeColumns}
    />
  );
};
